<template>
  <q-footer class="absolute-bottom top-bottom-panel footer">
    <div
      class="section-container flex items-center justify-between"
      style="height: 48px"
    >
      <div class="row col-sm-4 col-12 items-center">
        <div>Gambeat.io © 2023. All rights reserved</div>
      </div>
      <div class="row col-sm-8 col-12 items-center justify-end">
        <a class="flex" target="_blank" href="https://www.instagram.com/gambeat.io/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.4559 6.92083C17.4475 6.28968 17.3293 5.66481 17.1067 5.07416C16.9137 4.57595 16.6188 4.12349 16.241 3.74569C15.8632 3.36788 15.4108 3.07304 14.9126 2.87999C14.3295 2.66113 13.7135 2.54278 13.0909 2.52999C12.2892 2.49416 12.0351 2.48416 10.0001 2.48416C7.96506 2.48416 7.70423 2.48416 6.90839 2.52999C6.28602 2.54287 5.67035 2.66122 5.08756 2.87999C4.58927 3.0729 4.13674 3.3677 3.75892 3.74552C3.3811 4.12335 3.0863 4.57588 2.89339 5.07416C2.67408 5.65677 2.55599 6.27259 2.54423 6.89499C2.50839 7.69749 2.49756 7.95166 2.49756 9.98666C2.49756 12.0217 2.49756 12.2817 2.54423 13.0783C2.55673 13.7017 2.67423 14.3167 2.89339 14.9008C3.08662 15.399 3.38164 15.8513 3.75959 16.229C4.13754 16.6066 4.59011 16.9013 5.08839 17.0942C5.66959 17.3218 6.28537 17.4486 6.90923 17.4692C7.71173 17.505 7.96589 17.5158 10.0009 17.5158C12.0359 17.5158 12.2967 17.5158 13.0926 17.4692C13.7152 17.4569 14.3312 17.3388 14.9142 17.12C15.4123 16.9267 15.8646 16.6318 16.2424 16.254C16.6202 15.8763 16.9151 15.4239 17.1084 14.9258C17.3276 14.3425 17.4451 13.7275 17.4576 13.1033C17.4934 12.3017 17.5042 12.0475 17.5042 10.0117C17.5026 7.97666 17.5026 7.71833 17.4559 6.92083ZM9.99506 13.835C7.86673 13.835 6.14256 12.1108 6.14256 9.98249C6.14256 7.85416 7.86673 6.12999 9.99506 6.12999C11.0168 6.12999 11.9967 6.53588 12.7192 7.25837C13.4417 7.98085 13.8476 8.96075 13.8476 9.98249C13.8476 11.0042 13.4417 11.9841 12.7192 12.7066C11.9967 13.4291 11.0168 13.835 9.99506 13.835ZM14.0009 6.88583C13.8829 6.88594 13.766 6.86278 13.657 6.81767C13.5479 6.77256 13.4489 6.7064 13.3654 6.62296C13.282 6.53952 13.2158 6.44044 13.1707 6.3314C13.1256 6.22236 13.1024 6.1055 13.1026 5.98749C13.1026 5.86958 13.1258 5.75282 13.1709 5.64388C13.216 5.53494 13.2822 5.43595 13.3656 5.35257C13.4489 5.26919 13.5479 5.20305 13.6569 5.15793C13.7658 5.1128 13.8826 5.08958 14.0005 5.08958C14.1184 5.08958 14.2352 5.1128 14.3441 5.15793C14.453 5.20305 14.552 5.26919 14.6354 5.35257C14.7188 5.43595 14.7849 5.53494 14.83 5.64388C14.8752 5.75282 14.8984 5.86958 14.8984 5.98749C14.8984 6.48416 14.4967 6.88583 14.0009 6.88583Z"
              fill="#373641"
            />
            <path
              d="M9.99493 12.485C11.377 12.485 12.4974 11.3646 12.4974 9.9825C12.4974 8.6004 11.377 7.48 9.99493 7.48C8.61284 7.48 7.49243 8.6004 7.49243 9.9825C7.49243 11.3646 8.61284 12.485 9.99493 12.485Z"
              fill="#373641"
            />
          </svg>
        </a>
        <a class="flex" target="_blank" href="https://t.me/gambeat_support">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.2208 3.0975L2.44583 8.795C1.4375 9.2 1.44333 9.7625 2.26083 10.0133L6.05416 11.1967L14.8308 5.65917C15.2458 5.40667 15.625 5.5425 15.3133 5.81917L8.2025 12.2367H8.20083L8.2025 12.2375L7.94083 16.1475C8.32416 16.1475 8.49333 15.9717 8.70833 15.7642L10.5508 13.9725L14.3833 16.8033C15.09 17.1925 15.5975 16.9925 15.7733 16.1492L18.2892 4.2925C18.5467 3.26 17.895 2.7925 17.2208 3.0975Z"
              fill="#373641"
            />
          </svg>
        </a>
        <a class="flex" target="_blank" href="https://www.facebook.com/profile.php?id=61560805705678">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10.0007 1.66833C5.39905 1.66833 1.66821 5.39917 1.66821 10.0008C1.66821 14.1592 4.71488 17.6058 8.69905 18.2333V12.41H6.58238V10.0008H8.69905V8.165C8.69905 6.075 9.94321 4.9225 11.8457 4.9225C12.7574 4.9225 13.7124 5.085 13.7124 5.085V7.13417H12.659C11.6257 7.13417 11.3024 7.7775 11.3024 8.43667V9.99917H13.6115L13.2424 12.4083H11.3024V18.2317C15.2865 17.6075 18.3332 14.16 18.3332 10.0008C18.3332 5.39917 14.6024 1.66833 10.0007 1.66833Z"
              fill="#373641"
            />
          </svg>
        </a>
      </div>
      <!--      <div class="row col-sm-4 col-12 justify-center">-->
      <!--        <a class="col-4 flex justify-center text-white" href="#">{{-->
      <!--          $t('offerta')-->
      <!--        }}</a>-->
      <!--        <a class="col-4 flex justify-center text-white" href="#">{{-->
      <!--          $t('rules')-->
      <!--        }}</a>-->
      <!--        <a class="col-4 flex justify-center text-white" href="#">FAQ</a>-->
      <!--      </div>-->
    </div>
  </q-footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped lang="scss">
.footer {
  color: #373641;
  background: #fbfbfb !important;
  a {
    color: #373641;
    &:not(:last-child) {
      margin-right: 12px;
    }
  }
}
</style>
